import { isObject } from '@pineapplelab/util';
import { Paging } from '../paging';
import { ILandingPageAboutUs } from 'src/app/interfaces/landing-page-about-us.interface';
import { IImage } from 'src/app/interfaces/image.interface';
import { ILandingPageOurValues } from 'src/app/interfaces/landing-page-our-values.interface';
import { FBase } from './FBase';

export class AboutUs extends FBase implements ILandingPageAboutUs {
    title: string;
    description: string;
    images: IImage[];
    ourVision: string;
    ourMission: string;
    ourValuesTitle: string;
    ourValues: ILandingPageOurValues[] = [];
    showTeam: boolean = true;
    showContact: boolean = true;
    showOurValues: boolean = true;
    contactTitle?: string;
    contactSubtitle?: string;

    constructor(json?: { [key: string]: any }) {
        super();
        if (isObject(json)) {
            this.fromJson(json);
        }
    }
}

export namespace AboutUs {
    export const PATH = 'about-us';
    export const PAGING = new Paging<AboutUs>(<Paging.IPaging>{
        collection: PATH,
    });
}
